<!-- -----------------------------------content ------------------------------->
<router-outlet></router-outlet>
<div class="wp-content">   
    <div class="container-large">
        <div class="row no-gutter">
            <!-- --------------------------- main-content  --------------------------->
            <div class="col-md-12 main">
               
                <!-- --------------------------- block link  --------------------------->
                <div routerLinkActive="display-none">
                    <!-- <app-block-link></app-block-link> -->
                    <!-- begin disable -->
                    <a routerLink="/feedback"></a>
                    <a routerLink="/search"></a>
                    <a routerLink="/sitemap"></a>
                    <a routerLink="/schedule"></a>
                    <a routerLink="/list"></a>
                    <a routerLink="/detail"></a>
                    <a routerLink="/login"></a>
                    <a routerLink="/album"></a>
                    <!-- begin disable -->
                </div>
                <!-- --------------------------- end block link  --------------------------->

            </div>
            <!-- --------------------------- end main-content  --------------------------->

        

        </div>
    </div>
</div>
<!-- ---------------------------------- end content ------------------------ -->